import React from "react";
import CardHeader from "./CardHeader/cardHeader";
import CardUsers from "./CardUsers/cardUsers";
import CardSearch from "./CardSearch/cardSearch";

import { Tabs } from "antd";

import AccountTabs from "../../../commons/components/AccountTabs";
import CardApplications from "./CardApplications/cardApplications";

function UsersScreen(props) {
    
    const { TabPane } = Tabs;

    return (
        <>
            <CardHeader />

            <AccountTabs>
                <TabPane tab="Usuários" key="1">
                    <CardSearch />
                    <CardUsers />
                </TabPane>
                
                <TabPane tab="Aplicações" key="2">
                    <CardApplications />
                </TabPane>
            </AccountTabs>
        </>
    )
}

export default UsersScreen
